import { Button } from "ui/components/button";
import Icon from "../icon";
import { PLUS } from "icons";
import { Link } from "react-router-dom";
import { useTimesheet } from "./context";
import AddDraftLogCard from "./card/add-draft-log";

export function AddDraftLogButton({ children, href, variant }) {
    const { date } = useTimesheet();

    if (typeof children === "function") {
        return children({ date });
    }

    if (href) {
        return (
            <Link to={href}>
                <Button>
                    {children ? (
                        children
                    ) : (
                        <>
                            <Icon icon={PLUS} />
                            Add Draft Log
                        </>
                    )}
                </Button>
            </Link>
        );
    }

    return (
        <Link to={href ? href : `/timesheet/draft/+?date=${date}`}>
            <Button variant={variant}>
                {children ? (
                    children
                ) : (
                    <>
                        <Icon icon={PLUS} />
                        Add Draft Log
                    </>
                )}
            </Button>
        </Link>
    );
}

export function AddDraftLog({ children, href, className }) {
    const { date } = useTimesheet();

    if (typeof children === "function") {
        return children({ date });
    }
    return (
        <AddDraftLogCard
            href={href ? href : `/timesheet/draft/+?date=${date}`}
            className={className}
        />
    );
}
